import * as React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { FormattedMessage, useIntl } from 'react-intl'
import Head from 'components/Head'
import { Page } from 'layouts/pages'
import { Content, Banner, Main } from 'components/page'
import * as Pill from 'components/pill'

export function Layout({ form, table }) {
    const intl = useIntl()
    const title = intl.formatMessage({
        description: 'Layout / AST',
        defaultMessage: 'Avalanche Skills Training (AST)',
    })

    return (
        <Page>
            <Head title={title} description={title} />
            <Banner url={BANNER}>
                <NavigationBar />
                {form}
            </Banner>
            <Main>
                <Content>{table}</Content>
            </Main>
        </Page>
    )
}

// Utils
function NavigationBar() {
    const { pathname } = useRouter()
    const index = pathname === '/training/courses' ? 0 : 1

    return (
        <Pill.Container>
            <Pill.Set activeIndex={index}>
                <Pill.Item>
                    <Link href="/training/courses">
                        <a>
                            <FormattedMessage
                                description="Layout ast/layouts"
                                defaultMessage="Courses"
                            />
                        </a>
                    </Link>
                </Pill.Item>
                <Pill.Item>
                    <Link href="/training/providers">
                        <a>
                            <FormattedMessage
                                description="Layout ast/layouts"
                                defaultMessage="Providers"
                            />
                        </a>
                    </Link>
                </Pill.Item>
            </Pill.Set>
        </Pill.Container>
    )
}

// Constants
const BANNER =
    'https://res.cloudinary.com/avalanche-ca/image/upload/c_scale,w_1000/c_scale,e_make_transparent:10,g_south_east,l_watermark:Dunford_RyenReverse,w_200/v1440539610/Youth/DSC_0339.jpg'
